import React from 'react';
export function Testimonios() {
  const testimonios = [{
    text: '"Llevaba años creyendo que era un problema genético. A las 3 semanas del Plan de 30 Días ya notaba la diferencia. Mi pareja no lo podía creer. Yo tampoco."',
    author: '— Martín R., 34 años · Buenos Aires'
  }, {
    text: '"Lo que más me sorprendió fue la parte mental. Siempre pensé que era físico, pero la ansiedad era el 80% del problema. El Tomo II me cambió la cabeza completamente."',
    author: '— Carlos M., 41 años · Córdoba'
  }, {
    text: '"Compré el sistema con dudas y terminé aplicando todo. Las meditaciones de audio son increíbles. Nunca pensé que algo así funcionaría pero los resultados hablan solos."',
    author: '— Diego F., 29 años · Rosario'
  }];
  return <section className="bg-[#080808] py-[36px] px-5" data-id="element-162">
      <div className="max-w-[1100px] mx-auto px-5" data-id="element-163">
        <h2 className="font-montserrat font-black text-[clamp(1.5rem,4vw,2.4rem)] text-brand-white uppercase text-center mb-2 leading-[1.15]" data-id="element-164">
          Lo que Dicen los Hombres
          <br data-id="element-165" />
          <span className="text-brand-red" data-id="element-166">que Ya Aplicaron el Sistema</span>
        </h2>
        <div className="w-[60px] h-[3px] bg-brand-red mx-auto mt-[10px] mb-[22px] rounded-[2px]" data-id="element-167"></div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[18px] mt-2.5" data-id="element-168">
          {testimonios.map((t, idx) => <div key={idx} className="bg-brand-black-card border border-[#1a1a1a] rounded-[10px] p-[24px_20px] transition-colors duration-300 hover:border-brand-red" data-id="element-169">
              <div className="text-brand-gold text-[0.95rem] tracking-[3px] mb-3" data-id="element-170">
                ★★★★★
              </div>
              <p className="text-[0.9rem] italic text-[#b0ab9f] leading-[1.7] mb-[14px]" data-id="element-171">
                {t.text}
              </p>
              <div className="font-montserrat text-[0.75rem] font-bold text-[#555] uppercase tracking-[1px]" data-id="element-172">
                {t.author}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}